import { Link, LinkProps } from 'react-router';

type Props = { disabled?: string | void } & LinkProps;

const CustomLinkReactRouter = (props: Props) => {
  const { disabled, ...standardProps } = props;
  return <Link {...standardProps} onClick={e => disabled && e.preventDefault()} />;
};
export default CustomLinkReactRouter;
